const RULES = [
  {
    title: "Para Toplama ve Ödeme",
    message: "Hiçbir şekilde kişisel hesaplara para alınamaz. Tüm ödemeler sadece dernek hesabı üzerinden yapılır.",
    date: "12.04.2025"
  },
  {
    title: "Kurul Onayı",
    message: "Her etkinlik veya faaliyet ilgili kurul başkanı ve yönetim onayı ile yapılır.",
    date: "12.04.2025"
  },
  {
    title: "İş Birliği",
    message: "Üyeler arasında dayanışma ve iş birliği esastır. Tüm çalışmalar ortak faydaya yönelik olmalıdır.",
    date: "12.04.2025"
  },
  {
    title: "Düzen ve Disiplin",
    message: "Toplantı ve etkinliklerde düzen, saygı ve disiplin korunur.",
    date: "12.04.2025"
  },
  {
    title: "Sorumluluk",
    message: "Her üye aldığı görevi zamanında ve eksiksiz yerine getirmekle yükümlüdür.",
    date: "12.04.2025"
  },
  {
    title: "Şeffaflık",
    message: "Tüm karar ve faaliyetler şeffaf şekilde üyelerle paylaşılır.",
    date: "12.04.2025"
  }
];

export default RULES;
